module.exports = __webpack_public_path__ + "img/planting_03@2x.ecf972a.webp";